<div
  class="btn btn-primary"
  [ngClass]="{ disabled: disabled }"
  (click)="!disabled && this.btnClick.emit()"
>
  <ng-content></ng-content>
</div>